import type { Module } from 'vuex';
import { PriceCurrency } from '@/types/PriceCurrency';
import {RootState} from "@/store";

export interface PriceCurrenciesState {
  priceCurrencies: PriceCurrency[];
}

const priceCurrenciesModule: Module<PriceCurrenciesState, RootState> = {
  namespaced: true,

  state: (): PriceCurrenciesState => ({
    priceCurrencies: [],
  }),

  getters: {
    getById: (state) => (indexCurrency: number): PriceCurrency | undefined => {
      return state.priceCurrencies.find(currency => currency.indexCurrency === indexCurrency);
    },
    getByCode: (state) => (code: string): PriceCurrency | undefined => {
      return state.priceCurrencies.find(currency => currency.code === code);
    },
  },

  mutations: {
    setPriceCurrencies(
      state,
      payload: { priceCurrencies: Record<number, any> }
    ) {
      state.priceCurrencies = Object
        .values(payload.priceCurrencies)
        .map(raw => PriceCurrency.fromRaw(raw));
    },

    setPriceCurrencyCreate(
      state,
      payload: {
        indexCurrency: number;
        code: string;
      }
    ) {
      state.priceCurrencies.push(new PriceCurrency(
        payload.indexCurrency,
        payload.code,
      ));
    },

  },

  actions: {
    wsSetPriceCurrencies({ commit }, payload) {
      commit('setPriceCurrencies', payload);
    },
    wsPriceCurrencyCreate({ commit }, payload) {
      commit('setPriceCurrencyCreate', payload);
    },
  },
};

export default priceCurrenciesModule;
